// columns/folioColumns.js
export const folioColumns = (openModal) => [
  {
    title: "Folio Number",
    dataIndex: "folio_number",
    key: "folio_number",
    render: (text, record) =>
      openModal ? (
        <button
          style={{
            padding: 0,
            border: "none",
            background: "none",
            color: "#1677ff",
            cursor: "pointer",
          }}
          onClick={() => openModal(record)}
        >
          {text}
        </button>
      ) : (
        text
      ),
  },
  {
    title: "AMC",
    dataIndex: "amc_name",
    key: "amc_name",
  },
  {
    title: "Total Investment",
    dataIndex: "total_investment",
    key: "total_investment",
    render: (v) => `₹${Number(v || 0).toLocaleString()}`,
  },
  {
    title: "Redemption / Switches",
    children: [
      {
        title: "Cost Amount",
        dataIndex: "redemption_cost_amount",
        key: "redemption_cost_amount",
        render: (v) => `₹${Number(v || 0).toLocaleString()}`,
      },
      {
        title: "Actual Amount",
        dataIndex: "redemption_actual_amount",
        key: "redemption_actual_amount",
        render: (v) => `₹${Number(v || 0).toLocaleString()}`,
      },
    ],
  },
  {
    title: "Remaining Value",
    children: [
      {
        title: "Cost Value",
        dataIndex: "remaining_cost_value",
        key: "remaining_cost_value",
        render: (v) => `₹${Number(v || 0).toLocaleString()}`,
      },
      {
        title: "Current Value",
        dataIndex: "current_value",
        key: "current_value",
        render: (v) => `₹${Number(v || 0).toLocaleString()}`,
      },
    ],
  },
];
